import { StateField } from '@codemirror/state';
import { Decoration, EditorView } from '@codemirror/view';

const OPENSENSE_TAG_REGEXP = /\{if_.*?\}|\{\/if_.*?\}/g;

const createDecorations = (doc) => {
  const decorations = [];
  const text = doc.toString();

  let match = OPENSENSE_TAG_REGEXP.exec(text);

  while (match) {
    const start = match.index;
    const end = start + match[0].length;
    const range = Decoration.mark({ class: 'opensense-tag' }).range(start, end);

    decorations.push(range);

    match = OPENSENSE_TAG_REGEXP.exec(text);
  }

  return Decoration.set(decorations);
};

export const opensenseStyles = EditorView.baseTheme({
  '.opensense-tag': {
    backgroundColor: '#d8ac1030',
    borderRadius: '20px',
    color: 'var(--color-orange-500)',
    padding: '1px 4px 3px'
  },
  '.cm-line .opensense-tag::selection': {
    backgroundColor: 'rgba(0,0,0,.15) !important',
    borderRadius: 'var(--border-radius-base)'
  }
});

export const opensenseHighlighting = StateField.define({
  create(state) {
    return createDecorations(state.doc);
  },
  update(decorations, tr) {
    if (tr.docChanged) {
      return createDecorations(tr.newDoc);
    }

    return decorations;
  },
  provide: (f) => EditorView.decorations.from(f)
});
